import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

export default defineNuxtPlugin(() => {
    return {
        provide: {
            newTour: (options = {}) =>
                driver({
                    showProgress: true,
                    allowClose: true,
                    overlayOpacity: 0.5,
                    stagePadding: 6,
                    progressText: 'Step {{current}} di {{total}}',
                    nextBtnText: 'Avanti',
                    prevBtnText: 'Indietro',
                    doneBtnText: 'Fine',
                    ...options,
                }),
        },
    };
});
